<template>
  <div ref="mapRef" class="mapBox"></div>
  <div class="mapBox mainBox">
    <nyTit pathUrl="/diliMarker" />

    <div class="map-layer-legend">
      <div v-for="item in mapLegendItems" :key="item.label">
        <i :style="{ background: item.color }"></i>
        <span>{{ item.label }}</span>
      </div>
    </div>

    <div class="map-zoom-tools">
      <button type="button" title="放大地图" @click.stop="zoomMap(1)">＋</button>
      <button type="button" title="还原视角" @click.stop="resetMapView">复位</button>
      <button type="button" title="缩小地图" @click.stop="zoomMap(-1)">－</button>
    </div>

    <div class="content">
      <div class="high-layer-left">
        <div class="overview-row">
          <div class="overview-card mechanism-card" v-for="item in state.overviewCards" :key="item.label">
            <!-- <div class="overview-icon"><span>{{ item.icon }}</span></div> -->
             <div class="overview-icon"><img src="../assets/img/fg.png" alt=""></div>
            <div class="overview-text">
              <div class="overview-label">{{ item.label }}</div>
              <div class="overview-value">{{ item.value }}</div>
            </div>
          </div>
        </div>

        <div class="layer-body">
          <div class="side-column">
            <InfoPanel title="当前图层状态">
              <div class="status-list">
                <p v-for="item in state.statusRows" :key="item.label">
                  <span>{{ item.label }}</span>{{ item.value }}
                </p>
              </div>
            </InfoPanel>

            <InfoPanel title="模块定位" class="module-card">
              <p class="panel-copy">
                针对上蔡县全域约1529平方公里范围，搭建高清卫星影像图层，定期更新亚米级遥感融合数据，完成影像几何校正并叠加至县域GIS底图，辅助呈现全县近期地表影像状况。
              </p>
            </InfoPanel>

            <InfoPanel title="应用说明" class="module-card small">
              <p class="panel-copy">
                面向农田监管、村镇规划、水系巡查和应急研判等业务场景，支撑耕地、村庄、道路、水系等地物识别与统计。
              </p>
            </InfoPanel>
          </div>

          <div class="middle-column">
            <InfoPanel title="影像更新信息" class="update-panel">
              <div class="update-row">
                <span>最新日期</span>
                <b>{{ latestImageDate }}</b>
              </div>
              <div class="update-row">
                <span>覆盖范围</span>
                <b>全域</b>
              </div>
              <div class="update-row">
                <span>分辨率</span>
                <b>优于1m</b>
              </div>
              <div class="coord-box">
                <div class="coord-icon"><img src="@/assets/img/zb1.png" alt=""></div>
                <div class="coord-text">
                  <span>坐标系统</span>
                  <b>CGCS2000</b>
                </div>
              </div>
            </InfoPanel>

            <InfoPanel title="观测能力" class="ability-panel">
              <div class="ability-text">
                农田分布、村镇布局、水系河道、道路路网、林地坑塘、设施大棚、地貌细节
              </div>
            </InfoPanel>
          </div>

          <div class="mechanism-column">
            <div class="mechanism-card">
              <div class="mechanism-title">数据更新机制</div>
              <div class="mechanism-subtitle">季度全域更新 | 分区域分级加载 | 坐标统一校准</div>

              <div class="mechanism-list">
                <div class="mechanism-item" v-for="item in state.mechanismCards" :key="item.title">
                  <div class="mechanism-icon"><img :src="item.icon" alt=""></div>
                  <h4>{{ item.title }}</h4>
                  <p>{{ item.desc }}</p>
                  <div class="process-flow" v-if="item.flow">
                    <span v-for="step in item.flow" :key="step">{{ step }}</span>
                  </div>
                </div>
              </div>

              <div class="value-bar">
                <span v-for="item in state.valueTabs" :key="item">{{ item }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="high-layer-right">
        <div class="right-grid">
          <div class="right-column">
            <InfoPanel title="规划指标" class="tall-panel">
              <div class="badge-list">
                <div class="badge-row wide" v-for="item in state.planningStats" :key="item.label">
                  <span>{{ item.label }}</span>
                  <b>{{ item.value }}</b>
                </div>
              </div>
            </InfoPanel>
            <div  class="info-panel short-panel village-panel">
              <p class="quick-copy">村庄名称: 上蔡县</p>
              <p class="quick-copy">建设类型: 乡村振兴示范村</p>
              <p class="quick-copy">面积: 约15.3平方公里</p>
              <p class="quick-copy">建议方向: 优化居住环境、发展</p>
              <p class="quick-copy">展特色农业、提升公共服务配套</p>
              <p class="quick-copy">村庄名称、建设类型、用地面积、建设方向</p>
            </div>
          </div>

          <div class="right-column">
            <InfoPanel title="巡查重点" class="tall-panel">
              <div class="badge-list patrol-list">
                <div class="badge-row" v-for="item in state.patrolStats" :key="item.label">
                  <span>{{ item.label }}</span>
                  <b>{{ item.value }}</b>
                  <em v-if="item.desc">{{ item.desc }}</em>
                </div>
              </div>
            </InfoPanel>
            <div  class="info-panel short-panel  village-panel">
              <p class="quick-copy">图斑编号: SC-047</p>
              <p class="quick-copy">资源类型: 建设用地</p>
              <p class="quick-copy">刷新影像: 2026-06-02</p>
              <p class="quick-copy">变化描述: 道路拓宽与民居整治</p>
              <p class="quick-copy">核查状态: 已完成</p>
            </div>
          </div>

          <div class="right-column">
            <InfoPanel title="应急指标" class="tall-panel">
              <div class="badge-list emergency-list">
                <div class="badge-row" v-for="item in state.emergencyStats" :key="item.label">
                  <span>{{ item.label }}</span>
                  <b>{{ item.value }}</b>
                  <em v-if="item.desc">{{ item.desc }}</em>
                </div>
              </div>
            </InfoPanel>
            <div  class="info-panel short-panel village-panel">
              <p class="quick-copy">区域: 上蔡县中部片区</p>
              <p class="quick-copy">灾害类型: 干旱与风雹</p>
              <p class="quick-copy">刷新影像: 2026-06-02</p>
              <p class="quick-copy">区域范围: 约28.6平方公里</p>
              <p class="quick-copy">历史对比: 2023-2026</p>
              <p class="quick-copy">编定单位: 自然资源核查组</p>
            </div>
          </div>

          <div class="right-column">
            <InfoPanel title="规划工具" class="tool-panel">
              <div class="tool-info">
                <div class="tool-row">
                  <span>最新日期</span>
                  <b>{{ latestImageDate }}</b>
                </div>
                <div class="tool-row">
                  <span>范围绘制</span>
                  <b>全域</b>
                </div>
                <div class="tool-row">
                  <span>选址评估、方案对比</span>
                </div>
                <div class="coord-box right-coord">
                  <div class="coord-icon"><img src="../assets/img/zb1.png" alt=""></div>
                  <div class="coord-text">
                    <span>坐标系统</span>
                    <b>CGCS2000</b>
                  </div>
                </div>
              </div>
            </InfoPanel>
            <InfoPanel title="分析任务" class="warning-panel">
              <div class="warning-list">
                <div class="badge-row" v-for="item in state.warningStats" :key="item.label">
                  <span>{{ item.label }}</span>
                  <b v-if="item.value">{{ item.value }}</b>
                </div>
              </div>
            </InfoPanel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { h, reactive, ref, onMounted, onUnmounted } from "vue";
import nyTit from "@/components/nyTit";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import Gep from "../utils/范围面.json";

const mapRef = ref(null);
const map = ref(null);
const mapObj = ref(null);
const markerIcon = require("@/assets/img/hs.png");
const boundaryData = Gep;
const defaultMapView = {
  center: [33.248258780732435, 114.18800353654662],
  zoom: 15,
};

function getDateOffsetLabel(offsetDays = 0) {
  const date = new Date();
  date.setDate(date.getDate() + offsetDays);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

const latestImageDate = getDateOffsetLabel(-1);

const mapLegendItems = [
  { label: "耕地保护覆盖面", color: "rgba(39, 255, 181, 0.72)" },
  { label: "水系巡查覆盖带", color: "rgba(62, 174, 255, 0.72)" },
  { label: "村镇建设观测区", color: "rgba(255, 205, 85, 0.72)" },
  { label: "高标农田影像区", color: "rgba(196, 117, 255, 0.72)" },
];

const state = reactive({
  overviewCards: [
    { label: "覆盖面积", value: "1529km²", icon: "▣" },
    { label: "影像来源", value: "高分系列/遥感融合", icon: "◇" },
    { label: "分辨率", value: "优于1m", icon: "▰" },
    { label: "坐标基准", value: "CGCS2000", icon: "▣" },
  ],
  statusRows: [
    { label: "图层运行状态：", value: "正常在线" },
    { label: "影像处理状态：", value: "已完成云量筛选与增强" },
  ],
  mechanismCards: [
    {
      title: "全域定时更新",
      icon: require("@/assets/img/jz.png"),
      desc: "按季度同步覆盖全域高清卫星影像，替换老旧底图，支持手动刷新缓存并重新发布图层服务。",
    },
    {
      title: "分区域分级加载",
      icon: require("@/assets/img/jz.png"),
      desc: "乡镇、村庄、高标准农田区域放大后加载高清影像，平原大田、河道周边采用中高分辨率图层。",
      flow: ["卫星接收", "云量筛选", "坐标校准", "瓦片更新", "图层发布"],
    },
    {
      title: "坐标统一校准",
      icon: require("@/assets/img/bz.png"),
      desc: "采用CGCS2000国家大地坐标系，与耕地地块、乡镇边界、路网矢量精准套合，减少影像偏移和错位。",
    },
  ],
  valueTabs: ["核心价值", "周期更新地表信息", "匹配县域边界", "支撑农田与资源监测"],
  planningStats: [
    { label: "村庄扩张趋势", value: "平稳" },
    { label: "疑似新增宅基地", value: "6处" },
    { label: "道路通达度", value: "87%" },
    { label: "道路优化点", value: "8处" },
    { label: "候选选址", value: "4处" },
    { label: "适建筛查面积", value: "1260亩" },
  ],
  patrolStats: [
    { label: "河道侵占疑点", value: "2处" },
    { label: "边界偏移疑点", value: "2处" },
    { label: "坑塘湿地变化", value: "4处" },
    { label: "林地变化", value: "3处", desc: "已复核" },
    { label: "村镇边界变化", value: "5处", desc: "待复核" },
    { label: "疑似违规建设", value: "3处" },
  ],
  emergencyStats: [
    { label: "风险影响面积", value: "320亩" },
    { label: "积水风险", value: "8处" },
    { label: "倒伏风险", value: "5处" },
    { label: "涝渍风险", value: "5处" },
    { label: "高风险地块", value: "7处", desc: "重点复核" },
  ],
  warningStats: [
    { label: "范围绘制", value: "12次" },
    { label: "路径分析", value: "5条" },
    { label: "选址评估", value: "8处" },
    { label: "方案对比", value: "3套" },
  ],
});

const InfoPanel = {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  setup(props, { slots, attrs }) {
    return () =>
      h("div", { ...attrs, class: ["info-panel", attrs.class] }, [
        h("div", { class: "panel-title" }, [h("i"), props.title]),
        h("div", { class: "panel-inner" }, slots.default ? slots.default() : []),
      ]);
  },
};

const markersData = [
  {
    locations: [
      [33.245220019410695, 114.19112205505373],
      [33.24651210282269, 114.18597221374513],
      [33.24220508383717, 114.18837547302248],
      [33.24609038325323, 114.19030666351318],
    ],
  },
];

const thematicCoverageAreas = [
  {
    name: "耕地保护覆盖面",
    color: "#27ffb5",
    coordinates: [
      [33.2603, 114.1708],
      [33.2594, 114.1878],
      [33.2511, 114.1964],
      [33.2429, 114.1911],
      [33.2459, 114.1746],
      [33.2548, 114.1659],
    ],
  },
  {
    name: "水系巡查覆盖带",
    color: "#3eaeff",
    coordinates: [
      [33.2648, 114.1811],
      [33.2622, 114.1867],
      [33.2577, 114.1914],
      [33.2522, 114.1971],
      [33.2496, 114.1951],
      [33.2549, 114.1888],
      [33.2592, 114.1845],
      [33.2621, 114.1789],
    ],
  },
  {
    name: "村镇建设观测区",
    color: "#ffcd55",
    coordinates: [
      [33.2517, 114.1958],
      [33.2495, 114.2076],
      [33.2419, 114.2072],
      [33.2394, 114.1962],
      [33.2448, 114.1898],
    ],
  },
  {
    name: "高标农田影像区",
    color: "#c475ff",
    coordinates: [
      [33.2398, 114.1628],
      [33.2482, 114.1679],
      [33.2476, 114.1814],
      [33.2374, 114.1843],
      [33.2316, 114.1741],
    ],
  },
];

const mapType1 = ref(
  L.tileLayer(
    "https://map1.aikenong.com.cn/maps/vt/lyrs=y&hl=zh-CN&gl=cn&scale=2&src=app&x={x}&y={y}&z={z}",
    {
      subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
      opacity: 0.82,
      pane: "countyRasterPane",
      className: "high-res-satellite-tile",
    }
  )
);

const mapLabelType1 = ref(
  L.tileLayer(
    "https://t0.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=cia&STYLE=default&FORMAT=tiles&TILEMATRIXSET=w&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=2543bd43d4f3f8b748d7ee2ecb82f74a",
    {
      subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
      pane: "countyLabelPane",
      opacity: 0.82,
    }
  )
);

const initMap = () => {
  map.value.createPane("countyRasterPane");
  map.value.getPane("countyRasterPane").style.zIndex = 360;
  map.value.createPane("countyThematicPane");
  map.value.getPane("countyThematicPane").style.zIndex = 370;
  map.value.createPane("countyLabelPane");
  map.value.getPane("countyLabelPane").style.zIndex = 390;
  map.value.addLayer(mapType1.value);
  map.value.addLayer(mapLabelType1.value);
  return map.value;
};

function createAndAddMarker(latlng, options = {}) {
  const marker = L.marker(latlng, options);
  marker.addTo(map.value);
  return marker;
}

function zoomMap(delta) {
  if (!map.value) return;
  if (delta > 0) {
    map.value.zoomIn(1);
  } else {
    map.value.zoomOut(1);
  }
}

function resetMapView() {
  if (!map.value) return;
  map.value.setView(defaultMapView.center, defaultMapView.zoom);
}

function createDashedPolyline(coordinates, style) {
  const latLngs = coordinates.map(([lng, lat]) => [lat, lng]);
  return L.polyline(latLngs, {
    ...style,
    dashArray: [5, 5],
    lineCap: "round",
    lineJoin: "round",
  });
}

const loadBoundary = () => {
  const layerStyle = {
    已建成: {
      color: "#39ffe0",
      fillColor: "#27ffb5",
      fillOpacity: 0.1,
    },
    未建成: {
      color: "#ffe56b",
      fillColor: "#ffcd55",
      fillOpacity: 0.2,
    },
    其他: {
      color: "#80d8ff",
      fillColor: "#3eaeff",
      fillOpacity: 0.3,
    },
  };

  L.geoJSON(boundaryData, {
    onEachFeature(feature, layer) {
      const featureType = feature.properties?.T || "其他";
      const currentStyle = layerStyle[featureType] || layerStyle.其他;
      const style = {
        color: currentStyle.color,
        fillColor: currentStyle.fillColor,
        fillOpacity: currentStyle.fillOpacity,
        dashArray: [1, 1],
        weight: 1.4,
      };

      if (feature.geometry.type === "Polygon" || feature.geometry.type === "MultiPolygon") {
        layer.setStyle(style);
        const rings =
          feature.geometry.type === "Polygon"
            ? [feature.geometry.coordinates[0]]
            : feature.geometry.coordinates.map((polygon) => polygon[0]);
        rings.forEach((ring) => map.value.addLayer(createDashedPolyline(ring, style)));
      } else if (feature.geometry.type === "LineString" || feature.geometry.type === "MultiLineString") {
        const coordinates =
          feature.geometry.type === "LineString"
            ? feature.geometry.coordinates
            : feature.geometry.coordinates[0];
        map.value.addLayer(createDashedPolyline(coordinates, style));
      }

      map.value.addLayer(layer);
    },
  }).addTo(map.value);
};

function loadThematicCoverage() {
  thematicCoverageAreas.forEach((area) => {
    L.polygon(area.coordinates, {
      pane: "countyThematicPane",
      color: area.color,
      weight: 3.5,
      opacity: 0.95,
      fillColor: area.color,
      fillOpacity: 0.075,
      dashArray: "8 8",
      lineJoin: "round",
    })
      .bindTooltip(area.name, {
        permanent: false,
        sticky: true,
        direction: "top",
        className: "coverage-label",
      })
      .addTo(map.value);
  });
}

const removeMap = () => {
  if (mapObj.value) {
    mapObj.value.remove();
    mapObj.value = null;
    map.value = null;
  }
};

onMounted(() => {
  map.value = L.map(mapRef.value, {
    center: defaultMapView.center,
    zoom: defaultMapView.zoom,
    minZoom: 3,
    maxZoom: 19,
    noWrap: true,
    zoomControl: false,
    zoomSnap: 0.5,
    zoomDelta: 0.5,
    wheelPxPerZoomLevel: 80,
    scrollWheelZoom: true,
    doubleClickZoom: true,
    touchZoom: true,
    dragging: true,
    attributionControl: false,
  });

  mapObj.value = initMap();
  loadBoundary();
  loadThematicCoverage();

  markersData.forEach((markerDatum) => {
    markerDatum.locations.forEach((latlng) => {
      createAndAddMarker(latlng, {
        title: "地标",
        icon: L.icon({
          iconUrl: markerIcon,
          iconSize: [34, 48],
          iconAnchor: [10, 10],
          popupAnchor: [-3, -76],
        }),
      });
    });
  });
});

onUnmounted(removeMap);
</script>

<style lang="less" scoped>
.mapBox {
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.mainBox {
  width: 100%;
  height: 100%;
  background: url(../../src/assets/img/map_bg.png);
  background-size: cover;
  position: relative;
  z-index: 2;
  pointer-events: none;
  overflow: hidden;
}

.mainBox :deep(.titleBg) {
  pointer-events: auto;
}

.mapBox :deep(.high-res-satellite-tile) {
  filter: brightness(0.76) contrast(1.16) saturate(1.22) hue-rotate(8deg);
}

.mapBox :deep(.leaflet-overlay-pane svg path) {
  filter: drop-shadow(0 0 4px rgba(72, 255, 232, 0.45));
}

.map-layer-legend {
  position: absolute;
  left: 50%;
  bottom: 96px;
  z-index: 8;
  transform: translateX(-50%);
  display: grid;
  grid-template-columns: repeat(4, auto);
  gap: 22px;
  padding: 16px 26px;
  box-sizing: border-box;
  pointer-events: auto;
  background:
    linear-gradient(180deg, rgba(4, 70, 69, 0.72), rgba(2, 32, 35, 0.86)),
    repeating-linear-gradient(90deg, rgba(61, 255, 234, 0.08) 0, rgba(61, 255, 234, 0.08) 1px, transparent 1px, transparent 24px);
  border: 1px solid rgba(76, 255, 235, 0.58);
  box-shadow: inset 0 0 22px rgba(48, 255, 226, 0.18), 0 0 20px rgba(38, 255, 231, 0.18);
  clip-path: polygon(16px 0, calc(100% - 16px) 0, 100% 16px, 100% calc(100% - 16px), calc(100% - 16px) 100%, 16px 100%, 0 calc(100% - 16px), 0 16px);
}

.map-layer-legend div {
  display: flex;
  align-items: center;
  color: #eafffb;
  font-size: 26px;
  line-height: 34px;
  font-weight: 800;
  white-space: nowrap;
}

.map-layer-legend i {
  width: 34px;
  height: 16px;
  margin-right: 10px;
  border: 1px solid rgba(255, 255, 255, 0.58);
  box-shadow: 0 0 12px currentColor;
}

.map-zoom-tools {
  position: absolute;
  right: 44%;
  top: 260px;
  z-index: 9;
  transform: translateX(520px);
  display: grid;
  grid-template-columns: 80px 80px 80px;
  gap: 20px;
  pointer-events: auto;
}

.map-zoom-tools button {
  width: 80px;
  height: 70px;
  border: 1px solid rgba(96, 255, 238, 0.78);
  color: #eafffb;
  font-size: 30px;
  line-height: 1;
  // font-weight: 900;
  cursor: pointer;
  background:
    linear-gradient(180deg, rgba(8, 92, 88, 0.58), rgba(3, 42, 43, 0.9)),
    repeating-linear-gradient(90deg, rgba(61, 255, 234, 0.08) 0, rgba(61, 255, 234, 0.08) 1px, transparent 1px, transparent 18px);
  box-shadow: inset 0 0 18px rgba(52, 255, 231, 0.2), 0 0 16px rgba(52, 255, 231, 0.18);
  clip-path: polygon(10px 0, calc(100% - 10px) 0, 100% 10px, 100% calc(100% - 10px), calc(100% - 10px) 100%, 10px 100%, 0 calc(100% - 10px), 0 10px);
}

.map-zoom-tools button:hover {
  color: #ffffff;
  border-color: rgba(175, 255, 247, 0.96);
  background:
    linear-gradient(180deg, rgba(17, 126, 116, 0.92), rgba(4, 58, 58, 0.92)),
    repeating-linear-gradient(90deg, rgba(61, 255, 234, 0.1) 0, rgba(61, 255, 234, 0.1) 1px, transparent 1px, transparent 18px);
}

.mapBox :deep(.coverage-label) {
  padding: 8px 14px;
  color: #ffffff;
  font-size: 24px;
  font-weight: 900;
  line-height: 30px;
  letter-spacing: 0;
  background: rgba(3, 35, 38, 0.68);
  border: 1px solid rgba(129, 255, 240, 0.72);
  box-shadow: 0 0 18px rgba(63, 255, 234, 0.34);
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.42);
}

.mapBox :deep(.coverage-label::before) {
  display: none;
}

.content {
  position: absolute;
  top: 210px;
  left: 100px;
  right: 100px;
  width: auto;
  height: calc(100% - 250px);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  pointer-events: auto;
}

.high-layer-left,
.high-layer-right {
  width: 2100px;
  height: 100%;
  color: #fff;
  font-family: "Microsoft YaHei", Arial, sans-serif;
  font-size: 26px;
  text-shadow: 0 0 8px rgba(31, 255, 236, 0.45);
}

.overview-row {
  height: 170px;
  display: grid;
  grid-template-columns: 450px 520px 470px 480px;
  gap: 60px;
  margin-bottom: 34px;
}

.overview-card {
  height: 165px;
  padding: 30px 28px 30px 52px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-width: 2px;
  clip-path: polygon(22px 0, calc(100% - 22px) 0, 100% 22px, 100% calc(100% - 22px), calc(100% - 22px) 100%, 22px 100%, 0 calc(100% - 22px), 0 22px);
}

.overview-icon {
  flex: none;
  width: 82px;
  height: 82px;
  margin-right: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-width: 4px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(38, 255, 236, 0.42), rgba(6, 87, 83, 0.3) 58%, rgba(8, 47, 48, 0.7));
  box-shadow: 0 0 0 4px rgba(26, 255, 234, 0.12), 0 0 16px rgba(26, 255, 234, 0.72), inset 0 0 12px rgba(26, 255, 234, 0.42);
}

.overview-icon img {
  width: 70px;
  height: 70px;
}

.overview-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.overview-label {
  font-size: 30px;
  line-height: 36px;
}

.overview-value,
.overview-card:nth-child(2) .overview-value,
.overview-card:nth-child(3) .overview-value,
.overview-card:nth-child(4) .overview-value {
  font-size: 48px;
  line-height: 58px;
}

.overview-card:nth-child(2) .overview-value {
  font-size: 40px;
}

.layer-body {
  height: 1160px;
  display: grid;
  grid-template-columns: 430px 390px 1240px;
  gap: 20px;
}

.side-column,
.middle-column {
  display: grid;
  gap: 20px;
}

.side-column {
  grid-template-rows: 300px 1fr 355px;
}

.middle-column {
  grid-template-rows: 560px 560px;
}

.info-panel,
.mechanism-card,
.mechanism-item {
  position: relative;
  background:
    linear-gradient(180deg, rgba(8, 89, 79, 0.56), rgba(2, 43, 42, 0.86)),
    repeating-linear-gradient(90deg, rgba(33, 255, 238, 0.05) 0, rgba(33, 255, 238, 0.05) 1px, transparent 1px, transparent 28px);
  border: 2px solid rgba(35, 255, 237, 0.68);
  border-width: 2px;
  clip-path: polygon(22px 0, calc(100% - 22px) 0, 100% 22px, 100% calc(100% - 22px), calc(100% - 22px) 100%, 22px 100%, 0 calc(100% - 22px), 0 22px);
  box-shadow: inset 0 0 42px rgba(0, 255, 222, 0.2), 0 0 20px rgba(0, 255, 222, 0.2);
}
.mechanism-card{
  height: 100%;
  padding: 30px 28px 30px 52px;
}
.info-panel {
  padding: 14px 26px 28px;
  box-sizing: border-box;
  overflow: hidden;
}

.panel-title {
  position: relative;
  width: 76%;
  height: 46px;
  display: flex;
  align-items: center;
  padding-left: 24px;
  color: #ffffff;
  font-size: 24px;
  font-weight: bold;
  line-height: 32px;
  text-align: left;
  background: linear-gradient(90deg, rgba(16, 119, 110, 0.9), rgba(11, 95, 91, 0.68), rgba(11, 95, 91, 0.14));
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.28);
}

.panel-title::before {
  content: "";
  position: absolute;
  left: -1px;
  top: 0;
  width: 12px;
  height: 100%;
  border-top: 1px solid rgba(121, 255, 247, 0.9);
  border-bottom: 1px solid rgba(121, 255, 247, 0.9);
  border-left: 1px solid rgba(121, 255, 247, 0.9);
  transform: skewX(-20deg);
  background: rgba(6, 60, 62, 0.62);
}

.panel-title::after {
  content: "";
  position: absolute;
  right: 12px;
  top: 0;
  width: 50px;
  height: 6px;
  background: repeating-linear-gradient(90deg, rgba(105, 255, 246, 0.88) 0 5px, transparent 5px 10px);
}

.panel-title i {
  display: none;
}


.status-list {
  margin-top: 44px;
  padding-left: 18px;
  font-size: 26px;
  line-height: 42px;
}

.status-list p {
  margin: 0;
}

.status-list span {
  color: #c5fdf6;
}

.panel-copy {
  margin: 34px 12px 0 16px;
  color: #f0fffe;
  font-size: 28px;
  line-height: 46px;
  font-weight: 700;
}

.update-row {
  height: 60px;
  margin-top: 30px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #eaffff;
  font-size: 26px;
  font-weight: bold;
  gap: 20px;
}

.update-row span {
  // width: 145px;
  text-align: left;
}

.update-row b {
  color: #33fff2;
  font-size: 30px;
}

.coord-box {
  height: 125px;
  margin: 34px 10px 0;
  padding: 22px 18px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  border: 2px solid rgba(31, 255, 236, 0.26);
  border-width: 2px;
  background: linear-gradient(90deg, rgba(8, 108, 99, 0.58), rgba(5, 59, 58, 0.22));
}

.coord-icon {
  flex: none;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 2px solid rgba(31, 255, 236, 0.9);
  background: radial-gradient(circle, rgba(38, 255, 236, 0.42), rgba(6, 87, 83, 0.3) 58%, rgba(8, 47, 48, 0.7));
  box-shadow: 0 0 0 4px rgba(26, 255, 234, 0.12), 0 0 16px rgba(26, 255, 234, 0.72), inset 0 0 12px rgba(26, 255, 234, 0.42);
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 50px;
    height: 50px;
  }
}
.coord-text{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
}


.coord-box span {
  display: block;
  color: #fff;
  font-size: 26px;
  line-height: 32px;
}

.coord-box b {
  display: block;
  color: #80fff7;
  font-size: 34px;
  line-height: 46px;
}

.ability-text {
  margin-top: 46px;
  padding: 0 18px;
  font-size: 32px;
  line-height: 60px;
  text-align: left;
}
.mechanism-title {
  height: 100px;
  line-height: 100px;
  text-align: center;
  color: #ffffff;
  font-size: 56px;
  font-weight: 900;
  position: relative;
}

.mechanism-title::before,
.mechanism-title::after {
  content: "";
  position: absolute;
  top: 53px;
  width: 390px;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(31, 255, 236, 0.75));
}

.mechanism-title::before {
  left: 0;
}

.mechanism-title::after {
  right: 0;
  transform: scaleX(-1);
}

.mechanism-subtitle {
  margin-bottom: 42px;
  text-align: center;
  color: #f8ffff;
  font-size: 28px;
  line-height: 38px;
  font-weight: bold;
}

.mechanism-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 62px;
}

.mechanism-item {
  height: 600px;
  padding: 78px 36px 28px;
  box-sizing: border-box;
  text-align: center;
}

.mechanism-icon {
  width: 108px;
  height: 108px;
  margin-bottom: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-width: 4px;
      border-radius: 50%;
    background: radial-gradient(circle, rgba(38, 255, 236, 0.42), rgba(6, 87, 83, 0.3) 58%, rgba(8, 47, 48, 0.7));
    box-shadow: 0 0 0 4px rgba(26, 255, 234, 0.12), 0 0 16px rgba(26, 255, 234, 0.72), inset 0 0 12px rgba(26, 255, 234, 0.42);
}

.mechanism-icon img {
  width: 92px;
  height: 92px;
}

.mechanism-item h4 {
  margin: 0 0 34px;
  color: #ffffff;
  font-size: 36px;
  line-height: 48px;
  font-weight: 800;
}

.mechanism-item p {
  margin: 0;
  color: #edfffe;
  font-size: 27px;
  line-height: 43px;
  text-align: left;
}

.process-flow {
  width: 380px;
  height: 130px;
  margin: 22px -24px 0;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: space-between;
}

.process-flow::before {
  content: "";
  position: absolute;
  top: 48px;
  left: 28px;
  width: 320px;
  height: 2px;
  background: rgba(31, 255, 236, 0.75);
}

.process-flow::after {
  content: "";
  position: absolute;
  left: 189px;
  top: 48px;
  width: 2px;
  height: 68px;
  background: rgba(31, 255, 236, 0.75);
}

.process-flow span {
  min-width: 92px;
  height: 45px;
  margin: 0 8px;
  position: relative;
  z-index: 1;
  color: #dffffc;
  font-size: 26px;
  line-height: 45px;
  background: rgba(10, 149, 139, 0.88);
  border: 2px solid rgba(31, 255, 236, 0.72);
  border-width: 2px;
  box-shadow: inset 0 0 10px rgba(31, 255, 236, 0.18);
}

.value-bar {
  height: 140px;
  margin-top: 70px;
  padding: 18px;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 170px 1fr 1fr 1fr;
  gap: 20px;
  background: linear-gradient(180deg, rgba(7, 89, 82, 0.42), rgba(3, 43, 42, 0.78));
  border: 2px solid rgba(31, 255, 236, 0.26);
  border-width: 2px;
}

.value-bar span,
.value-bar span:first-child {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ecfffd;
  font-size: 30px;
  font-weight: bold;
  background: linear-gradient(90deg, rgba(7, 117, 108, 0.94), rgba(12, 84, 78, 0.82));
  border: 2px solid rgba(31, 255, 236, 0.18);
  border-width: 2px;
}

.right-grid {
  width: 2100px;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 54px;
}

.right-column {
  display: grid;
  grid-template-rows: 720px 1fr;
  gap: 48px;
}

.right-column:last-child {
  grid-template-rows: 740px 1fr;
}

.tall-panel,
.short-panel,
.tool-panel,
.warning-panel {
  width: 100%;
}
.short-panel{
  p{
    text-align: left;
  }
}
.badge-list {
  padding: 36px 6px 0;
  box-sizing: border-box;
}

.badge-row {
  min-height: 68px;
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 26px;
  color: #eaffff;
  font-size: 30px;
  font-weight: 800;
}

.badge-row span {
  display: block;
  height: 68px;
  line-height: 68px;
  padding: 0 16px;
  color: #ffffff;
  font-size: 28px;
  background: linear-gradient(90deg, rgba(15, 160, 148, 0.95), rgba(7, 91, 84, 0.78));
  border-radius: 6px 20px 6px 20px;
  box-shadow: inset 0 0 16px rgba(31, 255, 236, 0.22);
}


.badge-row b {
  color: #cffffb;
  font-size: 32px;
  line-height: 52px;
}

.badge-row em {
  width: 100%;
  padding-left: 16px;
  color: #dffffc;
  font-style: normal;
  font-size: 28px;
  line-height: 34px;
}

.quick-line {
  margin: 28px 0 18px;
  color: #44fff3;
  font-size: 40px;
  font-weight: 900;
}

.quick-copy {
  margin: 0;
  color: #f3fffd;
  font-size: 30px;
  line-height: 56px;
  font-weight: 800;
  padding: 0 20px;
}

.tool-info {
  padding: 50px 12px 0;
}

.tool-row {
  min-height: 72px;
  display: flex;
  align-items: center;
  gap: 22px;
  color: #ffffff;
  font-size: 32px;
  line-height: 42px;
  font-weight: 800;
  margin-bottom: 54px;
}

.tool-row span {
  color: #f3fffd;
}

.tool-row b {
  color: #65fff5;
  font-size: 36px;
}

.right-coord {
  height: 130px;
  margin-top: 34px;
}

.warning-list {
  padding: 42px 8px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}

.warning-list .badge-row {
  margin-bottom: 36px;
}

.warning-list .badge-row span {
  min-width: 178px;
}

.warning-list .badge-row b {
  margin-left: auto;
}

/* 6364 * 1634 大屏适配 */
.content {
  position: absolute;
  top: 210px;
  left: 100px;
  right: 100px;
  width: auto;
  height: calc(100% - 250px);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  pointer-events: auto;
}

.high-layer-left,
.high-layer-right {
  width: 2100px;
  height: 100%;
  color: #fff;
  font-family: "Microsoft YaHei", Arial, sans-serif;
  font-size: 26px;
  text-shadow: 0 0 8px rgba(31, 255, 236, 0.45);
}
.high-layer-left{
  display: grid;
  grid-template-rows: 230px 1fr;
  gap: 20px;
}


.overview-icon {
  flex: none;
  width: 82px;
  height: 82px;
  margin-right: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-width: 4px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(38, 255, 236, 0.42), rgba(6, 87, 83, 0.3) 58%, rgba(8, 47, 48, 0.7));
  box-shadow: 0 0 0 4px rgba(26, 255, 234, 0.12), 0 0 16px rgba(26, 255, 234, 0.72), inset 0 0 12px rgba(26, 255, 234, 0.42);
}

.overview-icon img {
  width: 70px;
  height: 70px;
}

.overview-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.overview-label {
  font-size: 30px;
  line-height: 36px;
}

.overview-value,
.overview-card:nth-child(2) .overview-value,
.overview-card:nth-child(3) .overview-value,
.overview-card:nth-child(4) .overview-value {
  font-size: 48px;
  line-height: 58px;
}

.overview-card:nth-child(2) .overview-value {
  font-size: 40px;
}

.layer-body {
  height: 1160px;
  display: grid;
  grid-template-columns: 430px 390px 1240px;
  gap: 20px;
}


.middle-column {
  grid-template-rows: 560px 560px;
}

.info-panel,
.mechanism-card,
.mechanism-item {
  position: relative;
  background:
    linear-gradient(180deg, rgba(8, 89, 79, 0.56), rgba(2, 43, 42, 0.86)),
    repeating-linear-gradient(90deg, rgba(33, 255, 238, 0.05) 0, rgba(33, 255, 238, 0.05) 1px, transparent 1px, transparent 28px);
  border: 2px solid rgba(35, 255, 237, 0.68);
  border-width: 2px;
  clip-path: polygon(22px 0, calc(100% - 22px) 0, 100% 22px, 100% calc(100% - 22px), calc(100% - 22px) 100%, 22px 100%, 0 calc(100% - 22px), 0 22px);
  box-shadow: inset 0 0 42px rgba(0, 255, 222, 0.2), 0 0 20px rgba(0, 255, 222, 0.2);
}

.info-panel {
  padding: 14px 26px 28px;
  box-sizing: border-box;
  overflow: hidden;
}

.status-list {
  margin-top: 44px;
  padding-left: 18px;
  font-size: 26px;
  line-height: 42px;
}

.status-list p {
  margin: 0;
}

.status-list span {
  color: #c5fdf6;
}

.panel-copy {
  margin: 34px 12px 0 16px;
  color: #f0fffe;
  font-size: 28px;
  line-height: 46px;
  font-weight: 700;
}


.mechanism-title {
  height: 100px;
  line-height: 100px;
  text-align: center;
  color: #ffffff;
  font-size: 56px;
  font-weight: 900;
  position: relative;
}

.mechanism-title::before,
.mechanism-title::after {
  content: "";
  position: absolute;
  top: 53px;
  width: 390px;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(31, 255, 236, 0.75));
}

.mechanism-title::before {
  left: 0;
}

.mechanism-title::after {
  right: 0;
  transform: scaleX(-1);
}

.mechanism-subtitle {
  margin-bottom: 42px;
  text-align: center;
  color: #f8ffff;
  font-size: 28px;
  line-height: 38px;
  font-weight: bold;
}

.mechanism-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 62px;
}

.mechanism-item {
  height: 600px;
  padding: 38px 36px 28px;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.mechanism-item h4 {
  margin: 0 0 34px;
  color: #ffffff;
  font-size: 36px;
  line-height: 48px;
  font-weight: 800;
}

.mechanism-item p {
  margin: 0;
  color: #edfffe;
  font-size: 27px;
  line-height: 43px;
  text-align: left;
}

.process-flow {
  width: 380px;
  height: 130px;
  margin: 22px -24px 0;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: space-between;
}

.process-flow::before {
  content: "";
  position: absolute;
  top: 48px;
  left: 28px;
  width: 320px;
  height: 2px;
  background: rgba(31, 255, 236, 0.75);
}

.process-flow::after {
  content: "";
  position: absolute;
  left: 189px;
  top: 48px;
  width: 2px;
  height: 68px;
  background: rgba(31, 255, 236, 0.75);
}

.process-flow span {
  min-width: 92px;
  height: 45px;
  margin: 0 8px;
  position: relative;
  z-index: 1;
  color: #dffffc;
  font-size: 26px;
  line-height: 45px;
  background: rgba(10, 149, 139, 0.88);
  border: 2px solid rgba(31, 255, 236, 0.72);
  border-width: 2px;
  box-shadow: inset 0 0 10px rgba(31, 255, 236, 0.18);
}

.value-bar {
  height: 140px;
  margin-top: 70px;
  padding: 18px;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 170px 1fr 1fr 1fr;
  gap: 20px;
  background: linear-gradient(180deg, rgba(7, 89, 82, 0.42), rgba(3, 43, 42, 0.78));
  border: 2px solid rgba(31, 255, 236, 0.26);
  border-width: 2px;
}

.value-bar span,
.value-bar span:first-child {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ecfffd;
  font-size: 30px;
  font-weight: bold;
  background: linear-gradient(90deg, rgba(7, 117, 108, 0.94), rgba(12, 84, 78, 0.82));
  border: 2px solid rgba(31, 255, 236, 0.18);
  border-width: 2px;
}







.right-coord {
  height: 130px;
  margin-top: 34px;
}



:deep(.panel-title) {
  position: relative;
  height: 70px;
  display: flex;
  align-items: center;
  padding-left: 30px;
  color: #ffffff;
  font-size: 30px;
  font-weight: bold;
  line-height: 36px;
  text-align: left;
  background: linear-gradient(90deg, rgba(16, 119, 110, 0.9), rgba(11, 95, 91, 0.68), rgba(11, 95, 91, 0.14));
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.28);
}

:deep(.panel-title)::before {
  content: "";
  position: absolute;
  left: -1px;
  top: 0;
  width: 16px;
  height: 100%;
  border-top: 1px solid rgba(121, 255, 247, 0.9);
  border-bottom: 1px solid rgba(121, 255, 247, 0.9);
  border-left: 1px solid rgba(121, 255, 247, 0.9);
  transform: skewX(-20deg);
  background: rgba(6, 60, 62, 0.62);
}

:deep(.panel-title)::after {
  content: "";
  position: absolute;
  right: 12px;
  top: 0;
  width: 70px;
  height: 8px;
  background: repeating-linear-gradient(90deg, rgba(105, 255, 246, 0.88) 0 5px, transparent 5px 10px);
}

:deep(.panel-title i) {
  display: none;
}

:deep(.panel-inner) {
  position: relative;
  z-index: 1;
  font-size: 30px;
}
.village-panel {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  // padding: 14px 26px 28px;
}
</style>
